'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import Image from 'next/image';
import { useSession } from 'next-auth/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { useAppContext } from '@/app/_lib/_context';
export default function TradeHero(t0) {
  const $ = _c(28);
  const {
    slide,
    onApplyClick
  } = t0;
  const {
    openSignInModal
  } = useAppContext();
  const {
    data: session,
    status
  } = useSession();
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!slide) {
    return null;
  }
  const isSignedIn = mounted && status === "authenticated";
  const isTradeMember = mounted && session?.user?.tradeAccount === 1;
  let t3;
  if ($[2] !== slide.leftImage.alt || $[3] !== slide.leftImage.height || $[4] !== slide.leftImage.src || $[5] !== slide.leftImage.width) {
    t3 = <div className="w-full md:w-2/3"><Image src={slide.leftImage.src} alt={slide.leftImage.alt} width={slide.leftImage.width} height={slide.leftImage.height} className="w-full h-auto" priority={true} quality={90} sizes="(max-width: 768px) 100vw, 67vw" /></div>;
    $[2] = slide.leftImage.alt;
    $[3] = slide.leftImage.height;
    $[4] = slide.leftImage.src;
    $[5] = slide.leftImage.width;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== slide.rightImage.alt || $[8] !== slide.rightImage.height || $[9] !== slide.rightImage.src || $[10] !== slide.rightImage.width) {
    t4 = <div className="w-full md:w-1/3"><Image src={slide.rightImage.src} alt={slide.rightImage.alt} width={slide.rightImage.width} height={slide.rightImage.height} className="w-full h-auto" priority={true} quality={90} sizes="(max-width: 768px) 100vw, 33vw" /></div>;
    $[7] = slide.rightImage.alt;
    $[8] = slide.rightImage.height;
    $[9] = slide.rightImage.src;
    $[10] = slide.rightImage.width;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <div className="flex flex-col md:flex-row w-full">{t3}{t4}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FontAwesomeIcon icon={faHiveIconSmallLight} className="text-2xl md:text-3xl text-primary mt-0.5" />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute top-1/2 -translate-y-1/2 left-[var(--site-padding)] z-20 flex items-start gap-2">{t6}<div><h1 className="text-xl font-light transition-colors duration-500"><span className="lg:hidden">Trade Program</span><span className="hidden lg:inline">Welcome Design Professionals</span></h1><p className="text-sm md:text-base text-primary opacity-80">hive trade program</p></div></div>;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== isSignedIn || $[18] !== isTradeMember || $[19] !== mounted || $[20] !== onApplyClick || $[21] !== openSignInModal) {
    t8 = mounted && (isTradeMember ? <div className="text-white text-sm">Thank you for being a trade partner</div> : <><div className="flex items-center gap-3 mb-2"><span className="text-white text-sm font-medium whitespace-nowrap">Ready to join?</span><button onClick={onApplyClick} className="btn btn-xs bg-white text-dark hover:bg-gray-5 px-4">Apply</button></div><div className="text-white text-sm">{isSignedIn ? <span>Welcome back</span> : <>Already a member?{" "}<button onClick={openSignInModal} className="underline hover:text-primary transition-colors">Login</button></>}</div></>);
    $[17] = isSignedIn;
    $[18] = isTradeMember;
    $[19] = mounted;
    $[20] = onApplyClick;
    $[21] = openSignInModal;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t8) {
    t9 = <div className="absolute bottom-6 md:bottom-10 right-[var(--site-padding)] z-20 text-right">{t8}</div>;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t5 || $[26] !== t9) {
    t10 = <div className="relative">{t5}{t7}{t9}</div>;
    $[25] = t5;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}